// AlertPopup.js — global toast from useAlert(), Bauhaus: square plate with an
// accent rule (red error, yellow warning, blue info/success).
import useAlert from "../hooks/useAlert";

const ACCENT: Record<string, string> = {
  error: "var(--ev-red)",
  warning: "var(--ev-yellow)",
  info: "var(--ev-blue)",
  success: "var(--ev-blue)",
};

const AlertPopup = () => {
  const { text, type } = useAlert();

  if (text && type) {
    return (
      <div
        role={type === "error" ? "alert" : "status"}
        className="absolute z-10 m-3 max-w-md border-2 border-ev-rule bg-ev-bg px-4 py-3 text-sm text-ev-fg"
        style={{ borderLeft: `var(--ev-rule-w-thick) solid ${ACCENT[type] || "var(--ev-blue)"}` }}
      >
        {text}
      </div>
    );
  } else {
    return <></>;
  }
};

export default AlertPopup;
